import React, { useEffect, useState, useRef } from "react";

interface DocxViewerProps {
  blobUrl: string;
  className?: string;
}

const DocxViewer: React.FC<DocxViewerProps> = ({ blobUrl, className }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        if (!containerRef.current) return;
        const response = await fetch(blobUrl);
        const blob = await response.blob();
        // Dynamic import to avoid issues if not used
        const { renderAsync } = await import("docx-preview");

        if (active && containerRef.current) {
          containerRef.current.innerHTML = ""; // Clear previous
          await renderAsync(blob, containerRef.current, containerRef.current, {
            className: "docx-viewer", // Optional class for styling
            inWrapper: false,
            ignoreWidth: false,
            ignoreHeight: false,
            ignoreFonts: false,
            breakPages: true,
            ignoreLastRenderedPageBreak: true,
            experimental: false,
            trimXmlDeclaration: true,
            useBase64URL: false,
            debug: false,
          });
        }
      } catch (err: any) {
        console.error("Error rendering docx:", err);
        if (active)
          setError(
            `Failed to load document preview: ${err?.message || String(err)}`
          );
      }
    })();
    return () => {
      active = false;
    };
  }, [blobUrl]);

  if (error) return <div className="text-red-500 p-4">{error}</div>;

  return (
    <div
      ref={containerRef}
      className={`bg-white overflow-auto p-4 ${className || ""}`}
      style={{ width: "100%" }}
    />
  );
};

export default DocxViewer;
